export enum JobStatus {
    RUNNING = 'running',
    COMPLETED = 'complete',
    ERRORED = 'error',
    CANCELED = 'canceled',
    PAUSED = 'paused',
}

export enum JobType {
    CHILD = 'child',
    ROOT = 'root',
}
